import styles from './styles.module.css';
import React, { memo } from 'react';
import icMailBox from '../../assets/imgs/ic_mailbox.svg';
import { useTranslation } from 'react-i18next';

const ConfirmCodeDescription = memo(({ email }: { email: string }) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className={styles.description}>
                <div className={styles.mail}>
                    <p style={{ marginTop: 10 }}>{t('confirm-code.send-code', { email: email })}</p>
                </div>
                <div className={styles.iconMail}>
                    <img src={icMailBox} alt="top-mail-forgot" />
                </div>
                <p className={styles.mail}>{t('confirm-code.enter-code')}</p>
                <span className={styles.spamCheck}>{t('confirm-code.spam-check')}</span>
            </div>
        </React.Fragment>
    );
});

export default ConfirmCodeDescription;
